<template>
    <div
        class="el-cal-item"
        :style="{ borderColor: colorLuminance(background, -0.2), background }"
    >
        <div class="el-cal-item__title">
            <div
                class="el-cal-item__title-text"
                v-if="booking.start && booking.end"
            >
                {{ booking.start.format('HH:mm') }} -
                {{ booking.end.format('HH:mm') }}
            </div>
            <div
                class="el-cal-item__title-text"
                v-if="booking.actor && booking.actor.BookingReference"
            >
                <p>
                    {{ trans('form.label.bookingRef') }} :
                    {{ booking.actor.BookingReference }}
                </p>
                <p v-if="booking.actor && booking.actor.ActorType">
                    {{ this.actorType(booking.actor.ActorType) || '' }}
                </p>
            </div>
        </div>
        <div
            class="el-cal-item__resources-icon-list"
            v-if="booking.requestedResources"
        >
            <ul class="resources-icon-list inline-block">
                <li
                    v-if="booking.requestedResources.includes('FORKLIFT')"
                    class="resource-icon resource-icon__transporter"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TRUCK')"
                    class="resource-icon resource-icon__truck"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('MANPOWER')"
                    class="resource-icon resource-icon__team"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('CRANE')"
                    class="resource-icon resource-icon__crane"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TOOLS')"
                    class="resource-icon resource-icon__tools"
                ></li>
            </ul>
        </div>

        <!-- TOOL TIP 22222222 -->
        <div class="tippy-popper" ref="tooltip">
            <v-card class="white--text v-card-round" width="800">
                <v-card-title
                    primary-title
                    :style="`background-color : ${popoverBackground}`"
                >
                    <v-layout>
                        <v-flex xs5>
                            <div>
                                <div
                                    class="subheading mb-2"
                                    v-if="
                                        booking.actor &&
                                        booking.actor.BookingReference
                                    "
                                >
                                    <b>{{ booking.actor.BookingReference }}</b>
                                </div>
                                <div
                                    class="body-2 mb-1"
                                    v-if="
                                        booking.actor &&
                                        booking.actor.ActorType === 'MILKRUN'
                                    "
                                >
                                    <p>
                                        <b
                                            >{{
                                                trans('table.column.status')
                                            }}
                                            :</b
                                        >
                                        {{
                                            trans(
                                                `status.${booking.actor.StatusDescription}`
                                            ) || booking.actor.StatusDescription
                                        }}
                                    </p>
                                </div>
                                <div
                                    class="body-2 mb-1"
                                    v-if="
                                        booking.actor && booking.actor.PinCode
                                    "
                                >
                                    <b>{{ trans('form.label.pinCode') }} :</b>
                                    {{ booking.actor.PinCode }}
                                </div>
                                <div
                                    class="body-2 mb-1"
                                    v-if="
                                        booking.actor &&
                                        booking.actor.CreatedByUserName
                                    "
                                >
                                    <b>{{ trans('form.label.bookedBy') }} : </b
                                    >{{ booking.actor.CreatedByUserName }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs4> </v-flex>
                        <v-flex xs3 justify-end>
                            <div>
                                <div class="mb-3 body-2">
                                    <v-layout justify-space-around>
                                        <v-btn
                                            @click="
                                                openTimeline(
                                                    booking.actor.ActorID,
                                                    'ACTOR',
                                                    booking.actor
                                                        .BookingReference
                                                )
                                            "
                                            icon
                                            small
                                        >
                                            <v-icon>info</v-icon>
                                        </v-btn>
                                        <v-btn @click="viewBooking" icon small>
                                            <v-icon>visibility</v-icon>
                                        </v-btn>
                                        <v-btn @click="tippy.hide()" icon small>
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </div>
                                <p
                                    style="font-size: 16px; text-align: right"
                                    v-if="
                                        booking.actor &&
                                        booking.actor.AccessSets &&
                                        booking.actor.AccessSets.length > 0
                                    "
                                >
                                    <b>
                                        {{
                                            booking.actor.AccessSets[0]
                                                .UnloadingArea
                                        }}<br />
                                        {{
                                            this.actorType(
                                                booking.actor.ActorType
                                            ) || ''
                                        }}</b
                                    >
                                </p>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text class="pa-3 white black--text">
                    <v-layout>
                        <v-flex xs6>
                            <div
                                style="
                                    overflow-y: scroll;
                                    max-height: 150px;
                                    min-width: 300px;
                                "
                            >
                                <div
                                    v-for="(
                                        packageGroup, index
                                    ) in booking.actor.PackageGroups.slice().reverse()"
                                    :key="packageGroup.PackageGroupID"
                                    style="
                                        margin-top: 5px;
                                        padding: 4px;
                                        border: 1px #ecf0f9 solid;
                                    "
                                >
                                    <div class="body-1">
                                        <b
                                            >{{
                                                trans('data.label.referenceNo')
                                            }}
                                            :
                                        </b>
                                        {{ packageGroup.Reference }}
                                    </div>
                                    <div class="body-1">
                                        <b
                                            >{{ trans('data.label.supplier') }}
                                            :
                                        </b>
                                        {{ packageGroup.SupplierName }}
                                    </div>
                                    <div class="body-1">
                                        <b>{{ trans('data.label.items') }} :</b>
                                        <p
                                            v-for="(
                                                packageItem, index
                                            ) in packageGroup.PackageItems"
                                            :key="index"
                                            style="margin-left: 10px"
                                        >
                                            {{
                                                `${packageItem.Description} ${
                                                    packageItem.PackageType
                                                        ? `(${packageItem.PackageType})`
                                                        : ''
                                                }`
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs6>
                            <div v-if="booking.actor.AccessSets.length">
                                <div class="body-1">
                                    <b>
                                        {{ trans('form.label.recipientName') }}
                                        :
                                    </b>
                                    {{
                                        booking.actor.AccessSets[0]
                                            .RecipientName
                                    }}
                                </div>
                                <div class="body-1">
                                    <b
                                        >{{
                                            trans('form.label.recipientCompany')
                                        }}
                                        :
                                    </b>
                                    {{
                                        booking.actor.AccessSets[0]
                                            .RecipientCompany
                                    }}
                                </div>
                                <div class="body-1">
                                    <b
                                        >{{
                                            trans('form.label.recipientPhone')
                                        }}
                                        :
                                    </b>
                                    {{
                                        booking.actor.AccessSets[0]
                                            .RecipientPhone
                                    }}
                                </div>
                                <div class="body-1">
                                    <b>
                                        {{ trans('table.column.comments') }} :
                                    </b>
                                    {{ booking.actor.Comment }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-title primary-title :style="{ background: '#5D5E61' }">
                    <v-layout>
                        <v-flex xs4>
                            <div>
                                <div class="body-1">
                                    <b>
                                        {{ trans('form.label.usageTime') }} :</b
                                    >
                                    {{ booking.actor.UsageTimes }}
                                </div>
                                <div class="body-1">
                                    <b>
                                        {{ trans('form.label.maxUsageTime') }} :
                                    </b>
                                    {{ booking.actor.MaxUsageTimes }}
                                </div>
                                <div class="body-1">
                                    <b
                                        >{{ trans('form.label.numberPlate') }} :
                                    </b>
                                    {{ booking.actor.PlateNo }}
                                </div>
                                <div
                                    v-if="booking.actor.IsLocked"
                                    class="body-1"
                                >
                                    <i
                                        class="material-icons"
                                        v-if="booking.actor.IsLocked"
                                        style="font-size: 16px"
                                    >
                                        lock
                                    </i>
                                    <b> {{ trans('form.label.locked') }} : </b>
                                    {{ booking.actor.LockedByUserName }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs4>
                            <div>
                                <div class="body-1">
                                    <b>
                                        {{ trans('table.data.label.preFlex') }}
                                        :
                                    </b>
                                    {{ getPreFlex(booking.actor) }} mins
                                </div>
                                <div class="body-1">
                                    <b>
                                        {{
                                            trans(
                                                'form.label.unloadingTimeInMin'
                                            )
                                        }}
                                        :
                                    </b>
                                    {{ booking.actor.UnloadingTimeInMins }} mins
                                </div>
                                <div class="body-1">
                                    <b> {{ trans('form.label.created') }} : </b>
                                    {{ booking.actor.Created | formatDateTime }}
                                </div>
                                <div class="body-1">
                                    <b> {{ trans('form.label.updated') }} : </b>
                                    {{ booking.actor.Updated | formatDateTime }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex
                            xs4
                            v-if="
                                booking.actor.RouteReference ||
                                booking.actor.DriverUserFullName ||
                                booking.actor.VehicleDescription
                            "
                        >
                            <div>
                                <div
                                    class="body-1"
                                    v-if="booking.actor.RouteReference"
                                >
                                    <b> {{ trans('form.label.route') }} : </b>
                                    {{ booking.actor.RouteReference }}
                                </div>
                                <div
                                    class="body-1 mb-1"
                                    v-if="booking.actor.DriverUserFullName"
                                >
                                    <b>
                                        {{ trans('table.column.driverName') }} :
                                    </b>
                                    {{ booking.actor.DriverUserFullName }}
                                </div>
                                <div
                                    class="body-1 mb-1"
                                    v-if="booking.actor.VehicleDescription"
                                >
                                    <b> {{ trans('form.title.vehicle') }} : </b>
                                    {{ booking.actor.VehicleDescription }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import tippy from 'tippy.js'

export default {
    name: 'booking-overview-milkrun-event',

    props: {
        booking: {
            type: Object,
            default: () => {},
        },

        containers: {
            type: Array,
            default: () => {},
        },

        trans: {
            default: () => null,
        },

        route: {
            default() {
                return []
            },
        },

        element: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        background() {
            if (this.booking.actor.ActorType === 'SLOT') {
                return this.booking.actor.Color
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_CONFIRMED') {
                return '#67c23a'
            }

            if (
                this.booking.actor.StatusDescription ===
                'DELIVERY_PARTIALLY_CONFIRMED'
            ) {
                return '#e0e254'
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_COMPLETE') {
                return '#236B66'
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_PARTIAL') {
                return '#f9a825'
            }

            return '#00b4ff'
        },

        popoverBackground() {
            if (this.booking.actor.ActorType === 'SLOT') {
                return this.booking.actor.Color
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_CONFIRMED') {
                return '#67c23a'
            }

            if (
                this.booking.actor.StatusDescription ===
                'DELIVERY_PARTIALLY_CONFIRMED'
            ) {
                return '#e0e254'
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_COMPLETE') {
                return '#236B66'
            }

            if (this.booking.actor.StatusDescription === 'DELIVERY_PARTIAL') {
                return '#f9a825'
            }

            return '#00b4ff'
        },

        packageGroupItems() {
            return _.flatMap(this.booking.actor.PackageGroups, 'PackageItems')
        },

        destinationContainer() {
            return _.find(this.containers, {
                ContainerID: this.booking.actor.AccessSets[0]
                    .DestinationContainerID,
            })
        },
    },

    mounted() {
        if (this.$refs.tooltip && this.$refs.tooltip.firstChild) {
            this.tippy = tippy.one(this.element.get(), {
                arrow: true,
                arrowTransform: 'scale(1.2)',
                html: this.$refs.tooltip.firstChild,
                interactive: true,
                livePlacement: true,
                delay: 100,
                trigger: 'click',
            })
        }

        this.$once('hook:beforeDestroy', () => {
            this.tippy.destroy()
        })
    },

    methods: {
        colorLuminance(hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '')
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
            }
            lum = lum || 0

            // convert to decimal and change luminosity
            var rgb = '#',
                c,
                i
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16)
                c = Math.round(
                    Math.min(Math.max(0, c + c * lum), 255)
                ).toString(16)
                rgb += ('00' + c).substr(c.length)
            }

            return rgb
        },

        viewBooking() {
            this.tippy.hide()
            this.$emit('view-booking', this.booking)
        },
        actorType(type = '') {
            if ('milkrun' === type.toLowerCase()) {
                return this.trans('text.milkrun').toUpperCase()
            }

            if ('SLOT' === type.toUpperCase()) {
                return this.trans('text.direct').toUpperCase()
            }

            return type
        },
        getPreFlex(b) {
            let preFlex =
                b.AccessSets &&
                b.AccessSets[0] &&
                b.AccessSets[0].Schedules &&
                b.AccessSets[0].Schedules[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0].PreFlex

            return preFlex || 0
        },

        openTimeline(id, type, code) {
            Events.$emit('show-timeline', id, type, code)
            this.tippy.hide()
        },
    },
}
</script>
<style>
.v-card-round {
    border-radius: 10px;
}
.tippy-tooltip {
    color: inherit !important;
    font-size: inherit !important;
    padding: 0 !important;
    max-width: inherit !important;
    text-align: inherit !important;
    background-color: transparent !important;
}
.tippy-popper[x-placement^='top'] .tippy-arrow {
    border-top-color: #eeeeee !important;
}
.tippy-popper[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #eeeeee !important;
}
.tippy-popper[x-placement^='left'] .tippy-arrow {
    border-left-color: #eeeeee !important;
}
.tippy-popper[x-placement^='right'] .tippy-arrow {
    border-right-color: #eeeeee !important;
}
/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #cbcbcb;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
